import Dexie, { Table } from 'dexie';
import { NzUploadFile } from 'ng-zorro-antd/upload';

export interface FileToUpload {
  timestamp: number;
  uid: string;
  file: NzUploadFile;
  controlName?: string;
  data: string | ArrayBuffer | null;
  s3Path: string;
  formDefinitionId?: string;
}

export interface FileToDelete {
  uid: string;
  controlName?: string;
  s3Path: string;
  formDefinitionId?: string;
}

export interface DynamicFormEntry {
  _id: string;
  isNew: boolean;
  isModified: boolean;
  isArchived: number;
  definitionId: string;
  lastModified: number;
  timestamp: number;
  content: any;
  changes?: any;
  collection: string;
  filesToUpload: Array<FileToUpload>;
  filesToDelete: Array<FileToDelete>;
}

export interface ProgramMapFeaturesEntry {
  _id: string;
  timestamp: number;
  content: any;
}

export interface TilePropositionEntry {
  _id: string;
  content: any;
  propositionId: string;
}

export interface MapPropositionEntry {
  id: string;
  timestamp: number;
  content: any;
}

export interface MyProgramsEntry {
  id: string;
  timestamp: number;
  content: any;
}

export interface ProgramEntry {
  _id?: string;
  timestamp: number;
  content: any;
  currency: string;
}

export interface PropertyEntry {
  _id: string;
  isNew: boolean;
  isModified: boolean;
  isArchived: number;
  timestamp: number;
  content: any;
  changes?: any;
  filesToUpload: Array<FileToUpload>;
  filesToDelete: Array<FileToDelete>;
}

export interface SystemInstanceEntry {
  _id: string;
  isNew: boolean;
  isModified: boolean;
  isArchived: number;
  timestamp: number;
  content: any;
  changes?: any;
}

export interface ContactEntry {
  _id: string;
  timestamp: number;
  isNew: boolean;
  isModified: boolean;
  lastModified: number;
  isArchived: number;
  content: any;
  changes?: any;
  filesToUpload: Array<FileToUpload>;
  filesToDelete: Array<FileToDelete>;
}

export class DataDb extends Dexie {
  public dynamicForms!: Table<DynamicFormEntry>;
  public programMapFeatures!: Table<ProgramMapFeaturesEntry>;
  public programs!: Table<ProgramEntry>;
  public properties!: Table<PropertyEntry>;
  public systemInstances!: Table<SystemInstanceEntry>;
  public contacts!: Table<ContactEntry>;
  public tilePropositions!: Table<TilePropositionEntry>;
  public mapPropositions!: Table<MapPropositionEntry>;
  public myPrograms!: Table<MyProgramsEntry>;

  constructor() {
    super('dataFDM');
    this.version(31).stores({
      dynamicForms: '_id, timestamp, isArchived, [definitionId+isArchived]',
      programMapNamesAndIds: '_id, timestamp',
      programMaps: '_id, timestamp',
      programMapFeatures: '_id, timestamp',
      programs: '_id, timestamp',
      properties: '_id, timestamp, isArchived',
      systemInstances: '_id, timestamp, isArchived',
      contacts: '_id, timestamp, isArchived',
      shapeFormAssociations: '_id, timestamp',
      tilePropositions: '_id, propositionId',
      mapPropositions: 'id, timestamp',
      myPrograms: 'id, timestamp',
    });
  }
}

export const dataDb = new DataDb();
